import React from "react";
import { Box, MenuItem, Stack, Typography } from "@mui/material";

interface IDetail {
  data: any;
}

function Detail({ data }: IDetail) {
  return (
    <Stack
      component={MenuItem}
      gap={0.8}
      sx={{
        p: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRadius: "10px",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          color: "success.main",
        }}
      >
        22:00
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", color: "text.secondary" }}
      >
        <Typography>005.70</Typography>
        <Typography>20/24</Typography>
      </Stack>
      <Box
        sx={{
          width: "100%",
          height: "6px",
          backgroundColor: "background.default",
          borderRadius: "10px",
          position: "relative",
          "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: "80%",
            height: "100%",
            backgroundColor: "secondary.main",
            borderRadius: "10px 0px 0px 10px",
          },
        }}
      ></Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography sx={{ fontWeight: 600 }}>Đôi 500k</Typography>
        <Typography>SGĐL</Typography>
      </Stack>
    </Stack>
  );
}

export default Detail;
